/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Enter_ValidInputs */



/**
* | output |
* | --- |
* | "Please enter a valid {label}" |
*
* @param {Enter_ValidInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const enter_valid = /** @type {((inputs: Enter_ValidInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_ValidInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Please enter a valid ${i?.label}`)
	return /** @type {LocalizedString} */ (`Veuillez entrer un ${i?.label} valide`)
});